import DocViewerPage from "../pages/Document";
import { Outlet } from "react-router-dom";
import ProtectedRoute from "../components/auth/ProtectedRoute";

const SimpleRoutes = {
  path: "/",
  element: (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  ),
  children: [
    {
      path: "doc-view/:id",
      element: <DocViewerPage />,
    },
  ],
};

export default SimpleRoutes;
